// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link-budget-requests-lightbox {
  width: 350px;
}
.link-budget-requests-lightbox .pui-form-type-ahead-input-async-multi-select__search-input-wrap {
  display: flex;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
